import { map as map_1, bind, toArray, value as value_18 } from "../fable_modules/fable-library-js.4.29.0/Option.js";
import { curry3, createObj, uncurry3, uncurry2, compare as compare_1 } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { toString, Record } from "../fable_modules/fable-library-js.4.29.0/Types.js";
import { record_type, tuple_type, unit_type, option_type, int32_type, bool_type, lambda_type, class_type } from "../fable_modules/fable-library-js.4.29.0/Reflection.js";
import { SelectionMessage$1, SelectionMessage$1_$reflection } from "../Update.js";
import { Util_compareByDirection } from "../Types.js";
import { tryItem, sortWith, map, fold, mapIndexed } from "../fable_modules/fable-library-js.4.29.0/Array.js";
import { ofOption } from "./Prelude.js";
import { empty as empty_1, singleton, append, delay, toList, fold as fold_1 } from "../fable_modules/fable-library-js.4.29.0/Seq.js";
import { FSharpSet__get_IsEmpty, empty, add } from "../fable_modules/fable-library-js.4.29.0/Set.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { join } from "../fable_modules/fable-library-js.4.29.0/String.js";
import { checkboxHiddenText } from "./Input.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { singleton as singleton_1, ofArray } from "../fable_modules/fable-library-js.4.29.0/List.js";

function compareWithDirection(comparer, ascending) {
    if (ascending) {
        return (a) => ((b) => comparer(a, b));
    }
    else {
        return (a_1) => ((b_1) => comparer(b_1, a_1));
    }
}

function optionCompareByWith(projection, compare, a, b) {
    const matchValue = projection(a);
    const matchValue_1 = projection(b);
    if (matchValue == null) {
        if (matchValue_1 == null) {
            return 0;
        }
        else {
            return 1;
        }
    }
    else if (matchValue_1 == null) {
        return -1;
    }
    else {
        const a_1 = value_18(matchValue);
        const b_1 = value_18(matchValue_1);
        return compare(a_1, b_1) | 0;
    }
}

export function optionCompareDirection(projection, ascending) {
    const compare = compareWithDirection(compare_1, ascending);
    return (a) => ((b) => optionCompareByWith(projection, uncurry2(compare), a, b));
}

export class Column$2 extends Record {
    constructor(Header, Display, Sort, Select, Key, Disabled) {
        super();
        this.Header = Header;
        this.Display = Display;
        this.Sort = Sort;
        this.Select = Select;
        this.Key = Key;
        this.Disabled = Disabled;
    }
}

export function Column$2_$reflection(gen0, gen1) {
    return record_type("StardewValleyStonks.WebApp.View.Table.Column`2", [gen0, gen1], Column$2, () => [["Header", class_type("Fable.React.ReactElement", undefined)], ["Display", lambda_type(gen0, class_type("Fable.React.ReactElement", undefined))], ["Sort", option_type(lambda_type(bool_type, lambda_type(gen0, lambda_type(gen0, int32_type))))], ["Select", option_type(tuple_type(lambda_type(gen1, option_type(bool_type)), lambda_type(SelectionMessage$1_$reflection(gen1), unit_type)))], ["Key", bool_type], ["Disabled", bool_type]]);
}

export function Column_createWith(header, display, sort) {
    return new Column$2(header, display, sort, undefined, false, false);
}

export function Column_create(header, display) {
    return Column_createWith(header, display, undefined);
}

export function Column_sortable(header, display, sortBy) {
    return Column_createWith(header, display, uncurry3((ascending) => Util_compareByDirection(sortBy, ascending)));
}

export function Column_sortableOpt(header, display, sortBy) {
    return Column_createWith(header, display, uncurry3((ascending) => optionCompareDirection(sortBy, ascending)));
}

export function Column_valueSortable(header, value, display) {
    return Column_createWith(header, (arg) => display(value(arg)), uncurry3((ascending) => Util_compareByDirection(value, ascending)));
}

export function Column_valueOptSortable(header, value, display) {
    return Column_createWith(header, (arg) => display(value(arg)), uncurry3((ascending) => optionCompareDirection(value, ascending)));
}

export function Column_markAsKey(column) {
    return new Column$2(column.Header, column.Display, column.Sort, column.Select, true, column.Disabled);
}

export function Column_withDisabled(disabled, column) {
    return new Column$2(column.Header, column.Display, column.Sort, column.Select, column.Key, disabled);
}

export function Column_withSelect(selected, dispatch, column) {
    return new Column$2(column.Header, column.Display, column.Sort, [selected, dispatch], column.Key, column.Disabled);
}

function tableHeader(key, columns, items, sortCol, ascending, sortDispatch) {
    let children;
    const children_2 = singleton_1((children = mapIndexed((i, column) => {
        const i_1 = i >>> 0;
        const active = sortCol === i_1;
        const sortable = column.Sort != null;
        const xs_3 = [ofOption((tupledArg) => {
            let elems;
            const patternInput = fold((acc, item) => {
                const key_1 = key(item);
                return fold_1((tupledArg_1, selected_1) => [tupledArg_1[0] && selected_1, add(key_1, tupledArg_1[1])], acc, toArray(tupledArg[0](key_1)));
            }, [true, empty({
                Compare: compare_1,
            })], items);
            const keys_1 = patternInput[1];
            return createElement("th", createObj(ofArray([["scope", "col"], ["className", join(" ", toList(delay(() => append(singleton("column-select"), delay(() => (column.Disabled ? singleton("disabled") : empty_1()))))))], (elems = toList(delay(() => (FSharpSet__get_IsEmpty(keys_1) ? singleton(checkboxHiddenText("Select All", false, (value_4) => {
            })) : singleton(checkboxHiddenText("Select All", patternInput[0], (arg) => {
                let tupledArg_2;
                tupledArg[1]((tupledArg_2 = [keys_1, arg], new SelectionMessage$1(1, [tupledArg_2[0], tupledArg_2[1]])));
            }))))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
        }, column.Select), createElement("th", createObj(toList(delay(() => append(singleton(["scope", "col"]), delay(() => append(singleton(["className", join(" ", toList(delay(() => append(sortable ? singleton("column-sort") : empty_1(), delay(() => (column.Disabled ? singleton("disabled") : empty_1()))))))]), delay(() => append((sortable && active) ? singleton(["aria-sort", ascending ? "ascending" : "descending"]) : empty_1(), delay(() => {
            let elems_1;
            return singleton((elems_1 = toList(delay(() => (sortable ? singleton(createElement("button", {
                onClick: (_arg) => {
                    sortDispatch([i_1, active ? !ascending : true]);
                },
                "aria-pressed": active,
                children: column.Header,
            })) : singleton(column.Header)))), ["children", reactApi.Children.toArray(Array.from(elems_1))]));
        }))))))))))];
        return react.createElement(react.Fragment, {}, ...xs_3);
    }, columns), createElement("tr", {
        children: reactApi.Children.toArray(Array.from(children)),
    })));
    return createElement("thead", {
        children: reactApi.Children.toArray(Array.from(children_2)),
    });
}

function tableBody(key, columns, items, rowDisabled) {
    const children = map((item) => {
        const key_1 = key(item);
        return createElement("tr", createObj(toList(delay(() => append(singleton(["key", toString(key_1)]), delay(() => append(rowDisabled(item) ? singleton(["className", "disabled"]) : empty_1(), delay(() => {
            let elems;
            return singleton((elems = map((column) => {
                const xs_3 = toList(delay(() => append(singleton(ofOption((tupledArg) => createElement("td", {
                    className: join(" ", toList(delay(() => append(singleton("column-select"), delay(() => (column.Disabled ? singleton("disabled") : empty_1())))))),
                    children: ofOption((selected_1) => checkboxHiddenText("Select", selected_1, (arg) => {
                        let tupledArg_1;
                        tupledArg[1]((tupledArg_1 = [key_1, arg], new SelectionMessage$1(0, [tupledArg_1[0], tupledArg_1[1]])));
                    }), tupledArg[0](key_1)),
                }), column.Select)), delay(() => (column.Key ? singleton(createElement("th", createObj(toList(delay(() => append(singleton(["scope", "row"]), delay(() => append(column.Disabled ? singleton(["className", "disabled"]) : empty_1(), delay(() => singleton(["children", column.Display(item)])))))))))) : singleton(createElement("td", createObj(toList(delay(() => append(column.Disabled ? singleton(["className", "disabled"]) : empty_1(), delay(() => singleton(["children", column.Display(item)])))))))))))));
                return react.createElement(react.Fragment, {}, ...xs_3);
            }, columns), ["children", reactApi.Children.toArray(Array.from(elems))]));
        }))))))));
    }, items);
    return createElement("tbody", {
        children: reactApi.Children.toArray(Array.from(children)),
    });
}

export function tableFromColumnsWithRowDisable(rowDisabled, key, sortCol, ascending, sortDispatch, columns, items) {
    const items_2 = fold_1((items_1, sort) => sortWith(uncurry2(sort(ascending)), items_1), items, toArray(bind((col) => map_1(curry3, col.Sort), tryItem(~~sortCol, columns))));
    const children = ofArray([tableHeader(key, columns, items_2, sortCol, ascending, sortDispatch), tableBody(key, columns, items_2, rowDisabled)]);
    return createElement("table", {
        children: reactApi.Children.toArray(Array.from(children)),
    });
}

export function tableFromColumns(key, sort_, sort__1, sortDispatch, columns, items) {
    const sort = [sort_, sort__1];
    return tableFromColumnsWithRowDisable((arg10$0040) => false, key, sort[0], sort[1], sortDispatch, columns, items);
}

function collapseButton(expandLabel, collapseLabel, collapsed, setCollapsed) {
    return createElement("button", {
        className: "collapse-arrow",
        "aria-label": collapsed ? expandLabel : collapseLabel,
        "aria-pressed": !collapsed,
        onClick: (_arg) => {
            setCollapsed(!collapsed);
        },
    });
}

function CollapsibleTableBody(props) {
    let elems, xs_2;
    const patternInput = reactApi.useState(props.Collapsed);
    const setCollapsed = patternInput[1];
    const collapsed = patternInput[0];
    const dependencies = [props.AllCollapsed];
    reactApi.useEffect(() => {
        setCollapsed(props.AllCollapsed);
    }, dependencies);
    const children_2 = ofArray([createElement("tr", createObj(ofArray([["className", collapsed ? "collapsed" : "expanded"], (elems = [createElement("td", {
        children: [collapseButton("Expand", "Collapse", collapsed, setCollapsed)],
    }), props.Header], ["children", reactApi.Children.toArray(Array.from(elems))])]))), (xs_2 = map((row) => {
        const children = ofArray([createElement("td", {}), row]);
        return createElement("tr", {
            children: reactApi.Children.toArray(Array.from(children)),
        });
    }, props.Rows), react.createElement(react.Fragment, {}, ...xs_2))]);
    return createElement("tbody", {
        children: reactApi.Children.toArray(Array.from(children_2)),
    });
}

function CollapsibleTable(props) {
    let children_2, children, xs_1;
    const patternInput = reactApi.useState(props.Collapsed);
    const collapsed = patternInput[0];
    const xs_2 = [(children_2 = singleton_1((children = ofArray([createElement("td", {
        children: [collapseButton("Expand All", "Collapse All", collapsed, patternInput[1])],
    }), props.Header]), createElement("tr", {
        children: reactApi.Children.toArray(Array.from(children)),
    }))), createElement("thead", {
        children: reactApi.Children.toArray(Array.from(children_2)),
    })), (xs_1 = map((tupledArg) => {
        let children_4;
        const header = tupledArg[1];
        const body = tupledArg[2];
        if (body.length === 0) {
            const children_6 = singleton_1((children_4 = ofArray([createElement("td", {}), header]), createElement("tr", {
                children: reactApi.Children.toArray(Array.from(children_4)),
            })));
            return createElement("tbody", {
                children: reactApi.Children.toArray(Array.from(children_6)),
            });
        }
        else {
            return createElement(CollapsibleTableBody, {
                AllCollapsed: collapsed,
                Collapsed: props.Collapsed,
                Header: header,
                Rows: body,
                key: tupledArg[0],
            });
        }
    }, props.Bodies), react.createElement(react.Fragment, {}, ...xs_1))];
    return react.createElement(react.Fragment, {}, ...xs_2);
}

export function collapsibleHeaderAndBodies(collapsed, header, bodies) {
    return createElement(CollapsibleTable, {
        Bodies: bodies,
        Collapsed: collapsed,
        Header: header,
    });
}

//# sourceMappingURL=Table.js.map
